import { FC, ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Icon, Switch, Tooltip } from '@kontentino/ui';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { NavigationItem } from 'components/navigation/utils/libs';
import { getNavigationItemUrl } from 'components/navigation/utils/getNavigationItemUrl';

type Props = {
  routes: NavigationItem[];
  renderActiveAccessory?: (route: NavigationItem) => ReactNode;
};

const RouteTabSwitcher: FC<Props> = ({ routes, renderActiveAccessory }) => {
  const { pathname } = useLocation();

  const renderTab = (route: NavigationItem) => {
    if (!route.key) {
      return null;
    }

    const isActive = pathname === getNavigationItemUrl(route);

    return (
      <Tooltip content={route.label} key={route.key}>
        <Switch.Tab active={isActive} className="tw-h-[28px] tw-p-1">
          <Link
            to={getNavigationItemUrl(route)}
            data-name={`navigation-link-${route.key}`}
            data-cy={`navigation-link-${route.key}`}
          >
            <Icon icon={route.icon as IconDefinition} size={16} />
          </Link>
        </Switch.Tab>
      </Tooltip>
    );
  };

  const activeIndex = routes.findIndex(
    (route) => pathname === getNavigationItemUrl(route),
  );
  const accessory =
    renderActiveAccessory && activeIndex !== -1
      ? renderActiveAccessory(routes[activeIndex])
      : null;

  if (!accessory) {
    return <Switch.List>{routes.map(renderTab)}</Switch.List>;
  }

  return (
    <div className="tw-flex tw-items-center tw-gap-2">
      {accessory}
      <Switch.List>{routes.map(renderTab)}</Switch.List>
    </div>
  );
};

export default RouteTabSwitcher;
